import { useNavigate } from "react-router-dom";
import { SaveChangesModal } from "./modals/SaveChangesFirstModal";
import { PageHeader } from "@/components/organisms/PageHeader/PageHeader";
import { ExternalSupplierProfileProfileProvider, useExternalSupplierProfileProfileContext } from "./context";
import { ProfilePanel } from "./ProfilePanel/ProfilePanel";

export const ExternalSupplierProfilePanel = () => {
  const navigate = useNavigate();

  return (
    <ExternalSupplierProfileProfileProvider>
      <PageHeader.Actions onBack={() => navigate("../../")} />
      <Content />
    </ExternalSupplierProfileProfileProvider>
  );
};

const Content = () => (
  <>
    <ProfilePanel />
    <ProfileModals />
  </>
);

const ProfileModals = () => {
  const { activeModal, setActiveModal } = useExternalSupplierProfileProfileContext();

  return (
    <>
      <SaveChangesModal open={activeModal === "save-changes"} onClose={() => setActiveModal(undefined)} />
    </>
  );
};
